import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  path: string;
}

// SPA sem SSR - motores de busca modernos (Google) executam JS e leem isso, mas pra LLMs/
// crawlers mais simples que so leem o HTML inicial, o <title>/<meta description> do
// index.html (conteudo generico da Home) e o fallback. Cada pagina ainda assim atualiza isso
// em runtime pra quem executa JS, e pro compartilhamento (historico do browser, etc).
export function useSeo({ title, description, path }: SeoOptions) {
  useEffect(() => {
    const fullTitle = `${title} | SendCube`;
    document.title = fullTitle;

    const setMeta = (selector: string, attr: string, content: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, content);
    };

    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", `https://www.sendcube.com.br${path}`);
    setMeta('link[rel="canonical"]', "href", `https://www.sendcube.com.br${path}`);
  }, [title, description, path]);
}
